const getValue = (name) => (window?.env || {})[name]

export const config = {
  environment: getValue('ENVIRONMENT'),
  appVersion: getValue('APP_VERSION'),
  apiBaseUrl: getValue('METAPIC_API_URL'),
  mediaApiUrl: getValue('MEDIA_BASE_URL'),
  adminV2Url: getValue('ADMIN_URL'),
  advertiserApiUrl: getValue('ADVERTISER_APP_URL'),
  agencyAppUrl: getValue('AGENCY_APP_URL'),
  creatorAppUrl: getValue('CREATOR_APP_URL'),
  unleash: {
    proxyUrl: getValue('UNLEASH_PROXY_URL'),
    clientKey: getValue('UNLEASH_CLIENT_KEY'),
  },
  sentryDsn: getValue('SENTRY_DSN'),
  zezamRedirectUrl: getValue('ZEZAM_REDIRECT_URL'),
  zezamApiUrl: getValue('ZEZAM_API_URL'),
  powerBiUrl: getValue('POWER_BI_URL'),
  oryApiUrl: getValue('ORY_API_URL'),
  identityAppUrl: getValue('IDENTITY_APP_URL'),
  financeServiceApiBaseUrl: getValue('FINANCE_API_URL'),
}
